export default __webpack_public_path__ + "static/media/5d.a7bb4652.png";